import BaseView from '../views/BaseView';
import PageSlider from '../modules/PageSlider';
import PageQuotesSlider from '../modules/PageQuotesSlider';
import ScrollToTop from '../components/ScrollToTop';

export default class SinglePrint extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const groups = new Map([
			[PageSlider, this.container.querySelectorAll('[data-page-slider]')],
			[PageQuotesSlider, this.container.querySelectorAll('[data-quotes-slider]')],
			[ScrollToTop, [this.container]],
		]);

		super.createModules(groups);
	}
}
